import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { CommissionRes } from 'features/settings/types/settings.types'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

export const useFetchCommissions = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const { data: commissions, refetch: refetchCommissions } = useQuery<CommissionRes>({
		queryKey: queryKeys.commissions.all,
		queryFn: () => axiosPrivate.get(apiRoutes.commissions),
		enabled: !!auth.accessToken
	})

	return {
		commissions,
		refetchCommissions
	}
}
